<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<div class="page-container top-fix resize-index flex flex-col justify-start items-center min-h-[100vh]">
  <div class="white-card">
    <div class="login-content-terms-and-condition gap-[1.5em] flex flex-col justify-start items-start">
      <div class="flex flex-col self-stretch gap-[1.25em]">
        <div class="header-text bold500">Update to our Terms & Policies</div>
        <div class="main-text">
          We’ve updated our
          <span
            data-qa="link-terms-of-use"
            class="link clickable"
            (click)="redirectTerms()">
            Terms of use
          </span> and
          <span
            data-qa="link-privacy-policy"
            class="link clickable"
            (click)="redirectPolicy()">
            Privacy Policy
          </span>.
          Please read them as they will apply to your use of the SerVC platform.
        </div>
      </div>
      <div class="flex flex-row justify-between items-center gap-[0.5em]">
        <app-checkbox
          data-qa="terms-and-conditions-checkbox"
          class="terms-checkbox"
          [checked]="isUserAgreed"
          (checkBoxClicked)="toggleIsUserAgreed()">
          I have read everything and agree
        </app-checkbox>
      </div>
        <app-button
          data-qa="terms-of-use-btn"
          class="w-full"
          [disabled]="!isUserAgreed"
          [type]="'accent'"
          [additionalClasses] = "'w-full'"
          [bordersSquaredShape]="'full'"
          [size]="'large'"
          (buttonClick)="submit()">
          Continue
        </app-button>
    </div>
  </div>
</div>
